var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3419_57432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5356,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-180 20.5356 20)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3419_57432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5357 10.9999L13.7857 7.74988C13.9385 7.5971 14.1329 7.52071 14.369 7.52071C14.6051 7.52071 14.7996 7.5971 14.9524 7.74988C15.1051 7.90266 15.1815 8.0971 15.1815 8.33321C15.1815 8.56932 15.1051 8.76377 14.9524 8.91654L11.119 12.7499C10.9524 12.9165 10.7579 12.9999 10.5357 12.9999C10.3135 12.9999 10.119 12.9165 9.95235 12.7499L6.11902 8.91654C5.96624 8.76377 5.88985 8.56932 5.88985 8.33321C5.88985 8.0971 5.96624 7.90265 6.11902 7.74988C6.2718 7.5971 6.46624 7.52071 6.70235 7.52071C6.93846 7.52071 7.13291 7.5971 7.28569 7.74988L10.5357 10.9999Z",
    fill: "#1E1531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a7c20c0cc6b4573d793df14b63856d14.svg";
export { ForwardRef as ReactComponent };